<div [ngClass]="filterLabel ? 'filter-label' : 'form-label'">Category</div>

<ng-select
  (click)="$event.stopPropagation()"
  id="select_category"
  class="typeahead"
  [items]="categoryOptions()"
  [multiple]="true"
  bindLabel="name"
  bindValue="id"
  placeholder="Select one or more categories"
  [(ngModel)]="selectedCategories"
  (ngModelChange)="changeSelection()"
  (keydown)="changeSelection()">
</ng-select>
